module.exports = __webpack_public_path__ + "img/amex.8d6efc88.png";